module.exports = __webpack_public_path__ + "img/12.5c9c36d8.jpg";